module.exports = __webpack_public_path__ + "1869f962e887ef7bf7bf56170fda04e7.svg";